module.exports = __webpack_public_path__ + "static/dinosaur-999197a84d31b9a4f12fc7cfa2201563.png";